import React from 'react'
import ScrollComponents from '../../../../widgets/scrollComponents'
import './style.scss'

const fadeLeftInAnimation = {
  loop: false,
  from: { opacity: 0, x: -200 },
  to: { opacity: 1, x: 0 },
  config: {
    duration: 500,
  },
  delay: 300,
}

function StudyFrame() {
  return (
    <div className={'intro-content-container intro-frame-2-container'}>
      <ScrollComponents className={'intro-frame-2-text'} springConfig={fadeLeftInAnimation} />
    </div>
  )
}

export default StudyFrame
